import React from 'react';

const RemoveFavourites = () => {
    return (
        <div className="d-flex align-items-center justify-content-center">
            <span className="me-2">Remove</span>
            <i className="bi bi-star-fill" style={{ color: '#ffd700' }}></i>
        </div>
    );
};

export default RemoveFavourites;
